import Riding from './Riding'
import ObjectUtils from '../utils/ObjectUtils'

// For info, see https://www12.statcan.gc.ca/census-recensement/2011/ref/dict/table-tableau/table-tableau-8-eng.cfm

export default class Province {
  public static NL = new Province(10, 'Newfoundland and Labrador/Terre-Neuve-et-Labrador', 'NL') // prettier-ignore
  public static PE = new Province(11, 'Prince Edward Island/Île-du-Prince-Édouard', 'PE') // prettier-ignore
  public static NS = new Province(12, 'Nova Scotia/Nouvelle-Écosse', 'NS')
  public static NB = new Province(13, 'New Brunswick/Nouveau-Brunswick', 'NB')
  public static QC = new Province(24, 'Quebec/Québec', 'QC')
  public static ON = new Province(35, 'Ontario', 'ON')
  public static MB = new Province(46, 'Manitoba', 'MB')
  public static SK = new Province(47, 'Saskatchewan', 'SK')
  public static AB = new Province(48, 'Alberta', 'AB')
  public static BC = new Province(59, 'British Columbia/Colombie-Britannique', 'BC') // prettier-ignore
  public static YT = new Province(60, 'Yukon', 'YT')
  public static NT = new Province(61, 'Northwest Territories/Territoires du Nord-Ouest', 'NT') // prettier-ignore
  public static NU = new Province(62, 'Nunavut', 'NU')

  private static PROVINCE_ARR = [
    Province.NL,
    Province.PE,
    Province.NS,
    Province.NB,
    Province.QC,
    Province.ON,
    Province.MB,
    Province.SK,
    Province.AB,
    Province.BC,
    Province.YT,
    Province.NT,
    Province.NU
  ]
  private static PROVINCE_MAP = ObjectUtils.arrayToMap(
    Province.PROVINCE_ARR,
    (p): string => p.key
  )

  public static allProvincesArray(): Province[] {
    return Province.PROVINCE_ARR
  }

  public static allProvincesMap(): { [key: string]: Province } {
    return Province.PROVINCE_MAP
  }

  public static fromECName(ecName: string): Province {
    const province = Province.PROVINCE_ARR.find(
      (p: Province): boolean => p.ecName === ecName
    )
    if (!province) {
      throw new Error(`Province named ${ecName} not found.`)
    }
    return province
  }

  protected _code: number // The Standard Geographical Classification (SGC) code
  protected _ecName: string // Elections Canada name (bilingual)
  protected _shortName: string // Short name (Canada Post)
  protected _enName: string // English name
  protected _frName: string // French name
  protected _ridingsDict: { [key: string]: Riding } = {}

  public get code(): number {
    return this._code
  }

  public get key(): string {
    return this._shortName
  }

  public get ecName(): string {
    return this._ecName
  }

  public get shortName(): string {
    return this._shortName
  }

  public constructor(code: number, ecName: string, shortName: string) {
    this._code = code
    this._ecName = ecName
    this._shortName = shortName
    this._enName = ecName.includes('/') ? ecName.split('/')[0] : ecName
    this._frName = ecName.includes('/') ? ecName.split('/')[1] : ecName
  }

  public addRiding(riding: Riding): void {
    this._ridingsDict[riding.key] = riding
  }

  public name(language: string = 'en'): string {
    // Get the first part of the language code (encompasses en-ca, en-us, etc.)
    const langCode = language.split('-')[0]
    switch (langCode) {
      case 'fr':
        return this._frName
      case 'en':
      default:
        return this._enName
    }
  }

  public ridings(): Riding[] {
    return Object.values(this._ridingsDict)
  }
}
